import { TableUtils } from '../../../jscaip/TableUtils';
import { GameStateWithTable } from '../../../jscaip/state/GameStateWithTable';
export class MancalaState extends GameStateWithTable {
    scores;
    static of(state, board) {
        return new MancalaState(board, state.turn, state.getScoresCopy());
    }
    constructor(b, turn, scores) {
        super(b, turn);
        this.scores = scores;
    }
    setPieceAt(coord, value) {
        return GameStateWithTable.setPieceAt(this, coord, value, MancalaState.of);
    }
    feedStore(player) {
        const newScore = this.getScoresCopy();
        newScore.add(player, 1);
        return new MancalaState(this.getCopiedBoard(), this.turn, newScore);
    }
    feed(coord) {
        return this.addPieceAt(coord, 1);
    }
    addPieceAt(coord, value) {
        const previousValue = this.getPieceAt(coord);
        return this.setPieceAt(coord, previousValue + value);
    }
    getTotalRemainingSeeds() {
        return TableUtils.sum(this.board);
    }
    getScoresCopy() {
        return this.scores.getCopy();
    }
    /**
     * @param player the player that'll win point
     * @param coord the coord that'll get empty
     * @returns the resulting state in which 'player' emptied 'coord' to win all its seeds as point
     */
    capture(player, coord) {
        const capturedSeeds = this.getPieceAt(coord);
        const newScores = this.getScoresCopy();
        newScores.add(player, capturedSeeds);
        const result = new MancalaState(this.getCopiedBoard(), this.turn, newScores);
        return result.setPieceAt(coord, 0);
    }
    equals(other) {
        if (TableUtils.equals(this.board, other.board) === false)
            return false;
        if (this.scores.equals(other.scores) === false)
            return false;
        return this.turn === other.turn;
    }
}
